// Utility function to handle header scroll effects
export const initScrollDetection = () => {
  const handleScroll = () => {
    const header = document.querySelector('.header');
    if (!header) return;
    
    if (window.scrollY > 50) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  };
  
  // Función para solucionar el problema de hover persistente
  const fixHoverIssue = () => {
    const buttons = document.querySelectorAll('.contact-button');
    
    // Para cada botón, añadimos event listeners para arreglar el hover persistente
    buttons.forEach(button => {
      // Al perder el foco, eliminar cualquier estilo de hover persistente
      button.addEventListener('mouseleave', () => {
        // Forzar el reinicio de los estilos después de una pequeña espera
        setTimeout(() => {
          button.blur(); // Quitar el foco del elemento
          
          // Reiniciar los estilos CSS aplicados por el hover
          button.style.transform = '';
          button.style.boxShadow = '';
          
          // Eliminar y volver a añadir la clase para resetear los estilos
          const className = button.className;
          button.className = '';
          setTimeout(() => button.className = className, 10);
        }, 50);
      });
      
      // También reiniciar estilos al hacer clic
      button.addEventListener('click', () => {
        setTimeout(() => {
          button.blur();
        }, 100);
      });
    });
  };
  
  // Add scroll event listener
  window.addEventListener('scroll', handleScroll);
  
  // Aplicar la solución al hover persistente
  // Ejecutamos con un pequeño retraso para asegurar que los elementos estén cargados
  setTimeout(fixHoverIssue, 500);
  
  // Initial check
  handleScroll();
  
  // Return cleanup function
  return () => {
    window.removeEventListener('scroll', handleScroll);
  };
};
